import GetIcon from "../../../utils/Icon";

const itterFunc = (item, header) => {
  let key = header["key"];
  let value = item;
  let key_array = key.split(".");

  for (let i = 0; i < key_array.length; i++) {
    value = value?.[key_array[i]];
  }

  // Special handling for plan_duration
  if (key === "plan_duration" && value) {
    const [days, time] = value.split(" ");
    return (
      <td className="px-2 py-2">
        {days} days {time ?? "-"}
      </td>
    );
  }

  // 🔹 Check if custom render is defined in tableHeaders
  if (header.render) {
    return (
      <td className="px-2 py-2">
        {header.render(value, item)} 
      </td>
    );
  }

  // Default case
  return (
    <td className="px-2 py-2">
      {header.formatter ? header.formatter(value) : value ?? "-"}
    </td>
  );
};


const Table = ({ tabledata, tableClass, tableHeaders, actionButtons, onSort, sortKey }) => {
  return (
    <div
      className={`w-full overflow-x-auto ${tableClass ? tableClass : "px-2"}`}
    >
      <table className="w-full ">
        <thead>
          <tr className="bg-gray-100 text-left text-sm font-medium">
            {tableHeaders.map((header, index) => (
              <th
                key={index}
                onClick={header.sortable ? () => onSort(header.key) : undefined}
                className={`p-2 cursor-pointer ${
                  header.sortable ? "hover:bg-gray-200" : ""
                }`}
              >
                <p className="flex justify-between text-gray-700">
                  <span>{header.label}</span>

                  <span className={!header.sortable ? "hidden" : ""}>
                    {header.sortable && sortKey === header.key ? (
                      <GetIcon iconName="BsSortUp" design="text-primary" />
                    ) : (
                      <GetIcon iconName="BsSortDownAlt" />
                    )}
                  </span>
                </p>
              </th>
            ))}
            {actionButtons.length > 0 ? (
              <th className="p-2 text-gray-700">Action</th>
            ) : (
              ""
            )}
          </tr>
        </thead>

        <tbody>
          {tabledata.length > 0 ? (
            tabledata.map((row, index) => (
              <tr
                key={index}
                className="text-sm text-gray-700 hover:bg-gray-50 border-b border-gray-300"
              >
                {tableHeaders.map((header, colIndex) => {
                  if (header?.increameant) {
                    return (
                      <td key={colIndex} className="p-3 py-2 ">
                        {index + 1}
                      </td>
                    );
                  }
                  return itterFunc(row, header);
                })}
              

                  {actionButtons.length > 0 ? (
                    <td className=" px-2 py-2 flex items-center space-x-3 ">
                      {actionButtons.map((action, idx) => (
                        <GetIcon
                          key={idx}
                          action={() => action.onClick(row)}
                          iconName={action.icon}
                          size={17}
                          design="text-iconintable mt-1 hover:text-black  cursor-pointer"
                        />
                      ))}
                    </td>
                  ) : (
                    ""
                  )}
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={tableHeaders.length + 1}
                className="text-center py-4 text-gray-500"
              >
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
